import { Controller } from "@hotwired/stimulus"

// Toggles the admin sidebar as a drawer on viewports <768px. On ≥md the
// sidebar is always visible and the toggle is hidden, so this controller
// is effectively a no-op on desktop.
export default class extends Controller {
  static targets = ["sidebar", "backdrop"]

  connect() {
    this.close = this.close.bind(this)
    this.onKeydown = this.onKeydown.bind(this)
  }

  toggle(event) {
    event?.preventDefault()
    this.element.classList.toggle("is-open")
    if (this.element.classList.contains("is-open")) {
      document.addEventListener("keydown", this.onKeydown)
    } else {
      document.removeEventListener("keydown", this.onKeydown)
    }
  }

  close(event) {
    event?.preventDefault()
    this.element.classList.remove("is-open")
    document.removeEventListener("keydown", this.onKeydown)
  }

  onKeydown(event) {
    if (event.key === "Escape") this.close(event)
  }
}
